import React from 'react';
import { Redo2, Undo2 } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation.jsx';

export default function UndoRedoButtons({
  canUndo,
  canRedo,
  onUndo,
  onRedo,
  buttonComponent: ButtonComponent = 'button',
  buttonStyle = {},
  dividerStyle = {},
}) {
  const { t } = useTranslation();
  if (!canUndo && !canRedo) return null;

  return (
    <>
      {canUndo && (
        <ButtonComponent onClick={onUndo} style={buttonStyle}>
          <Undo2 size={13} />
          {t('common.undo')}
        </ButtonComponent>
      )}
      {canRedo && (
        <ButtonComponent onClick={onRedo} style={buttonStyle}>
          <Redo2 size={13} />
          {t('common.redo')}
        </ButtonComponent>
      )}
      <div style={{ width: 1, height: 20, background: 'rgba(255,255,255,0.15)', margin: '0 4px', ...dividerStyle }} />
    </>
  );
}
